"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { cn } from "../utils.js";
import { useDropdownContext } from "./context.js";
import { DropdownBaseItem } from "./DropdownBaseItem.js";
import { DropdownBaseList } from "./DropdownBaseList.js";
const DropdownUsersList = ({ items, className, selected, ...itemProps })=>{
    const { values, setItems } = useDropdownContext();
    useEffect(()=>{
        setItems(items.map((item)=>({
                ...item,
                label: item.name,
                type: 'user'
            })));
    }, [
        items
    ]);
    return /*#__PURE__*/ jsx(DropdownBaseList, {
        selected: selected,
        children: items.map((item)=>{
            const isSelected = values.includes(item.value);
            return /*#__PURE__*/ jsx(DropdownBaseItem, {
                value: item.value,
                searchKey: item.name,
                isSelected: isSelected,
                className: cn('tw-h-5.6 tw-py-0.8', isSelected && 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600', className),
                ...itemProps,
                children: /*#__PURE__*/ jsxs("div", {
                    className: "tw-flex tw-items-center tw-gap-0.8",
                    children: [
                        /*#__PURE__*/ jsx("img", {
                            src: item.avatar,
                            alt: item.name,
                            className: "tw-h-3.2 tw-w-3.2 tw-rounded-full"
                        }),
                        /*#__PURE__*/ jsxs("div", {
                            className: "tw-flex tw-flex-col tw-justify-between tw-h-4",
                            children: [
                                /*#__PURE__*/ jsx("div", {
                                    className: "tw-font-subtitle5 tw-line-clamp-1",
                                    children: item.name
                                }),
                                /*#__PURE__*/ jsx("div", {
                                    className: "tw-font-body5 tw-line-clamp-1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300",
                                    children: item.position
                                })
                            ]
                        })
                    ]
                })
            }, item.value);
        })
    });
};
export { DropdownUsersList };
